import React, { useState, useCallback, useEffect } from 'react';
import DataTableNativeML from '@/components/DataTableNativeML';
import TextField from '@material-ui/core/TextField';
import { Controller } from 'react-hook-form';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InputAdornment from '@material-ui/core/InputAdornment';
import MobileDatePicker from '@material-ui/lab/MobileDatePicker';
import NumberFormatML from '@/components/NumberFormatML';
// import DatePicker from '@material-ui/lab/DatePicker';
import { integralTypeList } from '@/constants.js';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { Box, Autocomplete, FormHelperText } from '@material-ui/core';
import { history, useLocation, useIntl } from 'umi';
import { useDispatch, useSelector } from 'dva';
import ChangeIntegralStyled from './ChangeIntegralStyled';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className="tab-content"
      {...other}
    >
      {value === index && (
        <Box style={{ overflowX: 'hidden' }} className="content-wrapper">
          {children}
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
//数字问题
const NumberFormatCustom = React.forwardRef((props, ref) => (
  <NumberFormatML {...props} allowNegative={false} ref={ref} decimalScale={0} />
));

const ChangeIntegral = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const theme = useTheme();
  const dispatch = useDispatch();
  const { control, setValue, errors, setSelectItem, setMoldingSelectItem } =
    props;
  const memberInfo = useSelector((state) => state.adjustDetail.memberDetail);

  const location = useLocation();

  // //选择数据的id
  const [chooseItemId, setChooseItemId] = useState([]);
  // //选择型动值数据的id
  const [chooseMoldingItemId, setChooseMoldingItemId] = useState([]);
  // const [itemCheckedAble, setItemCheckedAble] = useState([]);

  const { query, pathname } = location;
  const {
    id,
    tab,
    valueBefore,
    value,
    opt,
    remark,
    way,
    valueSource,
    // pageNum, pageSize, title, type
  } = query;
  useEffect(() => {
    if (memberInfo && !opt) {
      setValue('prePoint', memberInfo.totalPoint);
    }
  }, [memberInfo, opt, setValue]);
  useEffect(() => {
    if (opt === 'preview' && tab === '1') {
      const option = integralTypeList.find((i) => i.name === way);
      setValue('prePoint', valueBefore);
      setValue('point', value);
      setPoint(value);
      setValue('type', option.id);
      setType(option);
      setValue('reason', remark);
      setReason(remark);
    } else if (opt === 'preview' && tab === '2') {
      setValue('preTime', valueBefore);
      setTime(value);
      setValue('time', value);
      setValue('reason', remark);
      setReason(remark);
      const selectedId = Number(valueSource);
      let ids = [];
      ids.push(selectedId);
      setChooseItemId(ids);
    } else if (opt === 'preview' && tab === '3') {
      const option = integralTypeList.find((i) => i.name === way);

      setValue('preMoldingPoint', valueBefore);
      setValue('moldingPoint', value);
      setMoldingPoint(value);
      setValue('moldingType', option.id);
      setMoldingType(option);
      setValue('moldingReason', remark);
      setMoldingReason(remark);
    } else if (opt === 'preview' && tab === '4') {
      setValue('preMoldingTime', valueBefore);
      setMoldingTime(value);
      setValue('moldingTime', value);
      setValue('moldingReason', remark);
      setMoldingReason(remark);
      const selectedMoldingId = Number(valueSource);
      let moldingIds = [];
      moldingIds.push(selectedMoldingId);
      let ids = [];
      ids.push(selectedMoldingId);
      setChooseMoldingItemId(ids);
    }
  }, [valueBefore, opt, remark, setValue, tab, value, way, valueSource]);
  //关于调整积分
  const [point, setPoint] = useState();
  //调整积分类型
  const [type, setType] = useState(null);
  //调整积分原因
  const [reason, setReason] = useState();
  const [pageData, setPageData] = useState({ pageNum: 1, pageSize: 10 });
  const [pageDataMolding, setPageDataMolding] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const handlePageChange = (pageObj) => {
    setPageData({ ...pageData, ...pageObj });
  };
  const handlePageChangeMolding = (pageObj) => {
    setPageDataMolding({ ...pageDataMolding, ...pageObj });
  };
  // const [tab, setTab] = useState(1);
  const [time, setTime] = useState(null);

  //关于调整型动值
  const [moldingPoint, setMoldingPoint] = useState();
  //调整型动值类型
  const [moldingType, setMoldingType] = useState(null);
  //调整型动值原因
  const [moldingReason, setMoldingReason] = useState();
  const [moldingTime, setMoldingTime] = useState(null);
  //拿取数据
  const { data: datas, total } =
    useSelector((state) => state.adjustDetail?.integralHistory) || {};
  const { data: dataMolding, totalMolding } =
    useSelector((state) => state.adjustDetail?.integralHistoryMolding) || {};
  //筛选框
  const loadingEffect = useSelector((state) => state.loading);
  const integralHistoryLoading =
    loadingEffect.effects['adjustDetail/getIntegralHistory'];
  const integralHistoryMoldingLoading =
    loadingEffect.effects['adjustDetail/getIntegralHistoryMolding'];
  //换页
  const changePage = (obj) => {
    handlePageChange(obj);
  };
  // 发起请求
  const setUseCallback = useCallback(() => {
    dispatch({
      type: 'adjustDetail/getIntegralHistory',
      payload: {
        values: {
          limit: pageData.pageSize,
          page: pageData.pageNum,
          member_id: id,
        },
      },
    });
  }, [dispatch, id, pageData.pageSize, pageData.pageNum]);
  useEffect(() => {
    setUseCallback();
  }, [setUseCallback]);
  // 发起请求
  const setUseMoldingCallback = useCallback(() => {
    dispatch({
      type: 'adjustDetail/getIntegralHistoryMolding',
      payload: {
        values: {
          limit: pageDataMolding.pageSize,
          page: pageDataMolding.pageNum,
          memberId: id,
        },
      },
    });
  }, [dispatch, id, pageDataMolding.pageSize, pageDataMolding.pageNum]);
  useEffect(() => {
    setUseMoldingCallback();
  }, [setUseMoldingCallback]);

  const integralColumns = [
    {
      title: formatMessage({ id: 'adjustment.members.inetgral.c01.lbl01' }),
      align: 'center',
      id: 'orderNo',
      key: 'orderNo',
      width: 200,
    },
    {
      align: 'right',
      title: formatMessage({ id: 'adjustment.members.inetgral.c01.lbl02' }),
      key: 'point',
      id: 'point',
      width: 200,
    },
    {
      title: formatMessage({ id: 'adjustment.members.inetgral.c01.lbl03' }),
      align: 'center',
      id: 'expireDate',
      key: 'expireDate',
      width: 200,
    },
    {
      title: formatMessage({ id: 'adjustment.members.inetgral.c01.lbl04' }),
      align: 'right',
      id: 'leftPoint',
      key: 'leftPoint',
      width: 200,
    },
  ];
  const integralTimeColumns = [
    {
      type: 'checkbox',
      align: 'right',
      width: 100,
      disabled: opt === 'preview',
      onChange: (newSelected, item, newSelectedItemArr) => {
        if (opt !== 'preview') {
          setChooseItemId(newSelected);
          // setSelectItem(())
          setSelectItem(newSelectedItemArr[0]);
          if (newSelected.length > 0) {
            newSelectedItemArr[0]?.expireDate
              ? setValue('preTime', newSelectedItemArr[0]?.expireDate)
              : setValue('preTime', '');
          } else {
            setValue('preTime', '');
          }
        }
      },
    },
    {
      title: formatMessage({ id: 'adjustment.members.inetgral.c02.lbl01' }),
      align: 'left',
      id: 'orderNo',
      key: 'orderNo',
      width: 200,
    },
    {
      align: 'right',
      title: formatMessage({ id: 'adjustment.members.inetgral.c02.lbl02' }),
      key: 'point',
      id: 'point',
      width: 200,
    },
    {
      title: formatMessage({ id: 'adjustment.members.inetgral.c02.lbl03' }),
      align: 'center',
      id: 'expireDate',
      key: 'expireDate',
      width: 200,
    },
    {
      title: formatMessage({ id: 'adjustment.members.inetgral.c02.lbl04' }),
      align: 'right',
      id: 'leftPoint',
      key: 'leftPoint',
      width: 200,
    },
  ];
  const integralContent = (
    <>
      <Box width={1000} className="table-wrapper">
        <DataTableNativeML
          singleSelect
          loading={integralHistoryLoading}
          columns={integralColumns}
          changePage={changePage}
          page={pageData}
          data={datas}
          devicesMinWidth="auto"
          total={total}
          paging={true}
          columnKey="id"
        ></DataTableNativeML>
      </Box>
      <Box className="row">
        <Controller
          as={<TextField />}
          name="prePoint"
          variant="standard"
          className="member-level"
          label={formatMessage({ id: 'adjustment.members.inetgral.n03.lbl01' })}
          control={control}
          id="basic"
          disabled
          defaultValue={''}
        />
      </Box>
      <Box width={360} mt={4} className="row">
        <Controller
          name="type"
          control={control}
          rules={{
            required: true,
          }}
          error={Boolean(errors.type)}
          render={() => (
            <Autocomplete
              disabled={opt === 'preview'}
              id="clear-on-blur"
              options={integralTypeList}
              name="type"
              value={type}
              onChange={(e, newValue) => {
                setValue('type', newValue);
                setType(newValue);
              }}
              getOptionLabel={(option) => option.name}
              clearOnBlur
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={
                    <span>
                      <span className="red">*</span>
                      {formatMessage({
                        id: 'adjustment.members.inetgral.n03.rdo02',
                      })}
                    </span>
                  }
                  variant="standard"
                  rules={{
                    required: true,
                  }}
                  error={Boolean(errors.type)}
                  helperText={
                    Boolean(errors.type) &&
                    formatMessage({
                      id: 'adjustment.members.inetgral.n01.rdo01',
                    })
                  }
                />
              )}
            />
          )}
        ></Controller>
      </Box>
      <Box width={360} mt={4} className="row">
        {!opt ? (
          <Controller
            render={(rp) => (
              <TextField
                name="point"
                className="text-input-align-style input"
                value={rp.value ?? point}
                helperText={
                  Boolean(errors.point) &&
                  formatMessage({ id: 'adjustment.members.inetgral.n01.lbl02' })
                }
                error={Boolean(errors.point)}
                onChange={(e) => {
                  setPoint(e.target.value);
                  // const number = Number(e.target.value);
                  setValue('point', e.target.value);
                  return rp.value;
                }}
                InputProps={{
                  inputComponent: NumberFormatCustom,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className="clear-btn"
                        onClick={() => {
                          if (opt !== 'preview') {
                            setValue('point', '');
                            setPoint('');
                          }
                        }}
                        edge="end"
                      >
                        {point ? <ClearIcon className="clear-icon" /> : ''}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                variant="standard"
                label={
                  <span>
                    <span className="red">*</span>
                    {formatMessage({
                      id: 'adjustment.members.inetgral.n03.lbl03',
                    })}
                  </span>
                }
              />
            )}
            name="point"
            rules={{
              required: true,
            }}
            error={Boolean(errors.point)}
            control={control}
            helperText={
              Boolean(errors.point) &&
              formatMessage({ id: 'adjustment.members.inetgral.n01.lbl02' })
            }
            id="basic"
            defaultValue={''}
          />
        ) : (
          <Controller
            control={control}
            defaultValue={''}
            name="point"
            variant="standard"
            disabled
            label={
              <span>
                <span className="red">*</span>
                {formatMessage({ id: 'adjustment.members.inetgral.n03.lbl03' })}
              </span>
            }
            as={<TextField disabled />}
          />
        )}

        {/* <NumberFormatML /> */}
      </Box>
      <Box width={360} mt={4} className="row" mb={1}>
        <Controller
          render={(rp) => (
            <TextField
              disabled={opt === 'preview'}
              value={rp.value ?? reason}
              error={Boolean(errors.reason)}
              onChange={(e) => {
                setReason(e.target.value);
                setValue('reason', e.target.value);
                return rp.value;
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={() => {
                        if (opt !== 'preview') {
                          setReason('');
                          setValue('reason', '');
                        }
                      }}
                      edge="end"
                    >
                      {reason ? <ClearIcon className="clear-icon" /> : ''}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="standard"
              className="input"
              label={
                <span>
                  <span className="red">*</span>
                  {formatMessage({
                    id: 'adjustment.members.inetgral.n03.lbl04',
                  })}
                </span>
              }
            />
          )}
          name="reason"
          control={control}
          id="basic"
          rules={{
            required: true,
            validate: (e) => {
              const trimValue = e.trim();
              return Boolean(trimValue);
            },
          }}
          error={Boolean(errors.reason)}
          // helperText={
          //   errors?.reason?.type === 'required'
          //     ? '请输入调整积分原因'
          //     : '积分调整原因不能为空'
          // }
          defaultValue={''}
        />
        <FormHelperText error={Boolean(errors.reason)}>
          {errors?.reason?.type === 'required' &&
            formatMessage({ id: 'adjustment.members.inetgral.n01.lbl03' })}
          {errors?.reason?.type === 'validate' &&
            formatMessage({ id: 'adjustment.members.inetgral.n01.lbl04' })}
        </FormHelperText>
      </Box>
    </>
  );
  const integralTimeContent = (
    <>
      <Box className="table-wrapper" width={1000}>
        <DataTableNativeML
          singleSelect
          chooseIds={opt === 'preview' ? [Number(valueSource)] : chooseItemId}
          loading={integralHistoryLoading}
          columns={integralTimeColumns}
          itemCheckedAble={opt === 'preview' ? 'x' : 'expireDate'}
          changePage={changePage}
          page={pageData}
          data={datas}
          devicesMinWidth="auto"
          total={total}
          // paging={true}
          columnKey="id"
        ></DataTableNativeML>
      </Box>
      <Box width={360} mt={4} className="row">
        <Controller
          as={<TextField />}
          rules={{ required: true }}
          name="preTime"
          variant="standard"
          disabled
          className="member-level"
          label={formatMessage({ id: 'adjustment.members.inetgral.n04.lbl01' })}
          control={control}
          error={Boolean(errors.time)}
          helperText={
            Boolean(errors.reason) &&
            formatMessage({ id: 'adjustment.members.inetgral.n01.rdo05' })
          }
          id="basic"
          defaultValue={''}
        />
      </Box>
      <Box width={360} mt={4} className="row">
        <Controller
          control={control}
          name="time"
          defaultValue={null}
          rules={{ required: true }}
          render={() => (
            <MobileDatePicker
              inputFormat="yyyy/MM/dd"
              clearable
              okText={'确定'}
              disabled={opt === 'preview'}
              cancelText={'取消'}
              clearText={'清除'}
              value={time}
              onChange={(e) => {
                setValue('time', e);
                setTime(e);
              }}
              renderInput={(prop) => (
                <TextField
                  {...prop}
                  variant="standard"
                  error={Boolean(errors.time)}
                  helperText={
                    Boolean(errors.reason) &&
                    formatMessage({
                      id: 'adjustment.members.inetgral.n01.rdo05',
                    })
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="clear-btn"
                          onClick={() => {
                            if (!opt) {
                              setTime(null);
                              setValue('time', null);
                            }
                          }}
                          edge="end"
                        >
                          {time ? <ClearIcon className="clear-icon" /> : ''}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              label={
                <span>
                  <span className="red">*</span>
                  {formatMessage({
                    id: 'adjustment.members.inetgral.n04.lbl02',
                  })}
                </span>
              }
            />
          )}
        />
      </Box>
      <Box width={360} mt={4} className="row">
        <Controller
          render={(rp) => (
            <TextField
              disabled={opt === 'preview'}
              value={rp.value ?? reason}
              error={Boolean(errors.reason)}
              // helperText={Boolean(errors.reason) && '请输入调整积分有效期原因'}
              onChange={(e) => {
                setReason(e.target.value);
                setValue('reason', e.target.value);
                return rp.value;
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={() => {
                        if (opt !== 'preview') {
                          setReason('');
                          setValue('reason', '');
                        }
                      }}
                      edge="end"
                    >
                      {reason ? <ClearIcon className="clear-icon" /> : ''}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="standard"
              className="input"
              label={
                <span>
                  <span className="red">*</span>
                  {formatMessage({
                    id: 'adjustment.members.inetgral.n04.lbl03',
                  })}
                </span>
              }
            />
          )}
          name="reason"
          rules={{
            required: true,
            validate: (e) => {
              const trimValue = e.trim();
              return Boolean(trimValue);
            },
          }}
          error={Boolean(errors.reason)}
          // helperText={Boolean(errors.reason) && '请输入调整积分有效期原因'}
          control={control}
          id="basic"
          defaultValue={''}
        />
        <FormHelperText error={Boolean(errors.reason)}>
          {errors?.reason?.type === 'required' &&
            formatMessage({ id: 'adjustment.members.inetgral.n01.lbl03' })}
          {errors?.reason?.type === 'validate' &&
            formatMessage({ id: 'adjustment.members.inetgral.n01.lbl04' })}
        </FormHelperText>
      </Box>
    </>
  );
  const moldingColumns = [
    {
      title: formatMessage({ id: 'adjustment.members.inetgral.c01.lbl01' }),
      align: 'center',
      id: 'orderNo',
      key: 'orderNo',
      width: 200,
    },
    {
      align: 'right',
      title: '型动值',
      key: 'point',
      id: 'point',
      width: 200,
    },
    {
      title: '型动值过期时间',
      align: 'center',
      id: 'expireDate',
      key: 'expireDate',
      width: 200,
    },
    {
      title: '剩余型动值',
      align: 'right',
      id: 'leftPoint',
      key: 'leftPoint',
      width: 200,
    },
  ];
  const moldingTimeColumns = [
    {
      type: 'checkbox',
      align: 'right',
      width: 100,
      disabled: opt === 'preview',
      onChange: (newSelected, item, newSelectedItemArr) => {
        if (opt !== 'preview') {
          setChooseMoldingItemId(newSelected);
          // setSelectItem(())
          setMoldingSelectItem(newSelectedItemArr[0]);
          if (newSelected.length > 0) {
            newSelectedItemArr[0]?.expireDate
              ? setValue('preMoldingTime', newSelectedItemArr[0]?.expireDate)
              : setValue('preMoldingTime', '');
          } else {
            setValue('preTime', '');
          }
        }
      },
    },
    {
      title: formatMessage({ id: 'adjustment.members.inetgral.c02.lbl01' }),
      align: 'left',
      id: 'orderNo',
      key: 'orderNo',
      width: 200,
    },
    {
      align: 'right',
      title: '型动值',
      key: 'point',
      id: 'point',
      width: 200,
    },
    {
      title: '型动值过期时间',
      align: 'center',
      id: 'expireDate',
      key: 'expireDate',
      width: 200,
    },
    {
      title: '剩余型动值',
      align: 'right',
      id: 'leftPoint',
      key: 'leftPoint',
      width: 200,
    },
  ];
  const moldingContent = (
    <>
      <Box width={1000} className="table-wrapper">
        <DataTableNativeML
          singleSelect
          loading={integralHistoryMoldingLoading}
          columns={moldingColumns}
          changePage={handlePageChangeMolding}
          page={pageDataMolding}
          data={dataMolding}
          devicesMinWidth="auto"
          total={totalMolding}
          paging={true}
          columnKey="id"
        ></DataTableNativeML>
      </Box>
      <Box className="row">
        <Controller
          as={<TextField />}
          name="preMoldingPoint"
          variant="standard"
          className="member-level"
          label="原剩余型动值"
          control={control}
          id="basic"
          disabled
          defaultValue={''}
        />
      </Box>
      <Box width={360} mt={4} className="row">
        <Controller
          name="moldingType"
          control={control}
          rules={{
            required: true,
          }}
          error={Boolean(errors.type)}
          render={() => (
            <Autocomplete
              disabled={opt === 'preview'}
              id="clear-on-blur"
              options={integralTypeList}
              name="moldingType"
              value={moldingType}
              onChange={(e, newValue) => {
                setValue('moldingType', newValue);
                setMoldingType(newValue);
              }}
              getOptionLabel={(option) => option.name}
              clearOnBlur
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={
                    <span>
                      <span className="red">*</span>
                      调整型动值类型
                    </span>
                  }
                  variant="standard"
                  rules={{
                    required: true,
                  }}
                  error={Boolean(errors.moldingType)}
                  helperText={
                    Boolean(errors.preMoldingPoint) && '请选择调整型动值类型'
                  }
                />
              )}
            />
          )}
        ></Controller>
      </Box>
      <Box width={360} mt={4} className="row">
        {!opt ? (
          <Controller
            render={(rp) => (
              <TextField
                name="moldingPoint"
                className="text-input-align-style input"
                value={rp.value ?? moldingPoint}
                helperText={
                  Boolean(errors.moldingPoint) && '请输入本次调整型动值'
                }
                error={Boolean(errors.moldingPoint)}
                onChange={(e) => {
                  setPoint(e.target.value);
                  // const number = Number(e.target.value);
                  setValue('moldingPoint', e.target.value);
                  return rp.value;
                }}
                InputProps={{
                  inputComponent: NumberFormatCustom,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className="clear-btn"
                        onClick={() => {
                          if (opt !== 'preview') {
                            setValue('moldingPoint', '');
                            setMoldingPoint('');
                          }
                        }}
                        edge="end"
                      >
                        {moldingPoint ? (
                          <ClearIcon className="clear-icon" />
                        ) : (
                          ''
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                variant="standard"
                label={
                  <span>
                    <span className="red">*</span>
                    本次调整型动值
                  </span>
                }
              />
            )}
            name="moldingPoint"
            rules={{
              required: true,
            }}
            error={Boolean(errors.moldingPoint)}
            control={control}
            helperText={Boolean(errors.moldingPoint) && '请输入本次调整型动值'}
            id="basic"
            defaultValue={''}
          />
        ) : (
          <Controller
            control={control}
            defaultValue={''}
            name="moldingPoint"
            variant="standard"
            disabled
            label={
              <span>
                <span className="red">*</span>
                本次调整型动值
              </span>
            }
            as={<TextField disabled />}
          />
        )}

        {/* <NumberFormatML /> */}
      </Box>
      <Box width={360} mt={4} className="row" mb={1}>
        <Controller
          render={(rp) => (
            <TextField
              disabled={opt === 'preview'}
              value={rp.value ?? moldingReason}
              error={Boolean(errors.moldingReason)}
              onChange={(e) => {
                setReason(e.target.value);
                setValue('moldingReason', e.target.value);
                return rp.value;
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={() => {
                        if (opt !== 'preview') {
                          setMoldingReason('');
                          setValue('moldingReason', '');
                        }
                      }}
                      edge="end"
                    >
                      {moldingReason ? (
                        <ClearIcon className="clear-icon" />
                      ) : (
                        ''
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="standard"
              className="input"
              label={
                <span>
                  <span className="red">*</span>
                  本次调整原因
                </span>
              }
            />
          )}
          name="moldingReason"
          control={control}
          id="basic"
          rules={{
            required: true,
            validate: (e) => {
              const trimValue = e.trim();
              return Boolean(trimValue);
            },
          }}
          error={Boolean(errors.moldingReason)}
          // helperText={
          //   errors?.reason?.type === 'required'
          //     ? '请输入调整积分原因'
          //     : '积分调整原因不能为空'
          // }
          defaultValue={''}
        />
        <FormHelperText error={Boolean(errors.moldingReason)}>
          {errors?.moldingReason?.type === 'required' && '请输入调整型动值原因'}
          {errors?.moldingReason?.type === 'validate' &&
            '型动值调整原因不能为空'}
        </FormHelperText>
      </Box>
    </>
  );
  const moldingTimeContent = (
    <>
      <Box className="table-wrapper" width={1000}>
        <DataTableNativeML
          singleSelect
          chooseIds={
            opt === 'preview' ? [Number(valueSource)] : chooseMoldingItemId
          }
          loading={integralHistoryLoading}
          columns={moldingTimeColumns}
          itemCheckedAble={opt === 'preview' ? 'x' : 'expireDate'}
          changePage={handlePageChangeMolding}
          page={pageDataMolding}
          data={dataMolding}
          devicesMinWidth="auto"
          total={totalMolding}
          // paging={true}
          columnKey="id"
        ></DataTableNativeML>
      </Box>
      <Box width={360} mt={4} className="row">
        <Controller
          as={<TextField />}
          rules={{ required: true }}
          name="preMoldingTime"
          variant="standard"
          disabled
          className="member-level"
          label="原型动值过期时间"
          control={control}
          error={Boolean(errors.moldingTime)}
          helperText={
            Boolean(errors.moldingReason) &&
            formatMessage({ id: 'adjustment.members.inetgral.n01.rdo05' })
          }
          id="basic"
          defaultValue={''}
        />
      </Box>
      <Box width={360} mt={4} className="row">
        <Controller
          control={control}
          name="moldingTime"
          defaultValue={null}
          rules={{ required: true }}
          render={() => (
            <MobileDatePicker
              inputFormat="yyyy/MM/dd"
              clearable
              okText={'确定'}
              disabled={opt === 'preview'}
              cancelText={'取消'}
              clearText={'清除'}
              value={moldingTime}
              onChange={(e) => {
                setValue('moldingTime', e);
                setMoldingTime(e);
              }}
              renderInput={(prop) => (
                <TextField
                  {...prop}
                  variant="standard"
                  error={Boolean(errors.moldingTime)}
                  helperText={
                    Boolean(errors.moldingReason) && '调整积分过期时间不能为空'
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="clear-btn"
                          onClick={() => {
                            if (!opt) {
                              setMoldingTime(null);
                              setValue('moldingTime', null);
                            }
                          }}
                          edge="end"
                        >
                          {moldingTime ? (
                            <ClearIcon className="clear-icon" />
                          ) : (
                            ''
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              label={
                <span>
                  <span className="red">*</span>
                  调整型动值过期时间
                </span>
              }
            />
          )}
        />
      </Box>
      <Box width={360} mt={4} className="row">
        <Controller
          render={(rp) => (
            <TextField
              disabled={opt === 'preview'}
              value={rp.value ?? moldingReason}
              error={Boolean(errors.reason)}
              // helperText={Boolean(errors.reason) && '请输入调整积分有效期原因'}
              onChange={(e) => {
                setMoldingReason(e.target.value);
                setValue('moldingReason', e.target.value);
                return rp.value;
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={() => {
                        if (opt !== 'preview') {
                          setMoldingReason('');
                          setValue('moldingReason', '');
                        }
                      }}
                      edge="end"
                    >
                      {moldingReason ? (
                        <ClearIcon className="clear-icon" />
                      ) : (
                        ''
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="standard"
              className="input"
              label={
                <span>
                  <span className="red">*</span>
                  调整型动值有效期原因
                </span>
              }
            />
          )}
          name="moldingReason"
          rules={{
            required: true,
            validate: (e) => {
              const trimValue = e.trim();
              return Boolean(trimValue);
            },
          }}
          error={Boolean(errors.moldingReason)}
          // helperText={Boolean(errors.reason) && '请输入调整积分有效期原因'}
          control={control}
          id="basic"
          defaultValue={''}
        />
        <FormHelperText error={Boolean(errors.moldingReason)}>
          {errors?.moldingReason?.type === 'required' && '请输入调整型动值原因'}
          {errors?.moldingReason?.type === 'validate' &&
            '型动值调整原因不能为空'}
        </FormHelperText>
      </Box>
    </>
  );
  const tabList = [
    {
      key: '1',
      name: formatMessage({ id: 'adjustment.members.inetgral.n02.lbl01' }),
      child: integralContent,
      isHidden: opt === 'preview' && ['2', '3', '4'].includes(tab),
    },
    {
      key: '2',
      name: formatMessage({ id: 'adjustment.members.inetgral.n02.lbl02' }),
      child: integralTimeContent,
      isHidden: opt === 'preview' && ['1', '3', '4'].includes(tab),
    },
    {
      key: '3',
      name: '添加型动值管理',
      child: moldingContent,
      isHidden: opt === 'preview' && ['1', '2', '4'].includes(tab),
    },
    {
      key: '4',
      name: '型动值有效期管理',
      child: moldingTimeContent,
      isHidden: opt === 'preview' && ['1', '2', '3'].includes(tab),
    },
  ];
  // console.log('cpList', cpList);
  // const [pageData, setPageData] = useState({
  //   pageSize: 10,
  //   pageNum: 1,
  // });

  //切换tab
  // const handleChangeTab = (event, newValue) => {
  //   // setTab(newValue);
  //   history.replace({
  //     pathname,
  //     query: { ...query, tab: (newValue + 1).toString() },
  //   });
  // };

  return (
    <ChangeIntegralStyled theme={theme} opt={opt}>
      <Box className="second-wrapper">
        <Tabs
          value={Number(tab) - 1}
          onChange={(event, newValue) => {
            // setTab(newValue + 1);
            if (!opt) {
              history.replace({
                pathname,
                query: { ...query, tab: (newValue + 1).toString() },
              });
            }
          }}

          //  onChange={handleChangeTab}
        >
          {tabList.map(
            (item, index) =>
              !item.isHidden && (
                <Tab key={item.key} label={item.name} {...a11yProps(index)} />
              ),
          )}
        </Tabs>
        <div className="tab-content-wrapper">
          {tabList.map((i, index) => (
            <TabPanel value={Number(tab) - 1} index={index} key={i.key}>
              {i.child}
            </TabPanel>
          ))}
        </div>
      </Box>
    </ChangeIntegralStyled>
  );
};
export default ChangeIntegral;
